module.exports = __webpack_public_path__ + "static/media/06.ba9e7992.png";